import * as React from 'react'
const Autosuggest = require('react-autosuggest')

import './styles.css'

export default class Autocomplete extends React.Component<any, any> {
    render() {
        const {
            suggestions,
            onSuggestionSelected,
            onSuggestionsFetchRequested,
            onSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
            inputProps,
        } = this.props

        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionSelected={onSuggestionSelected}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Autocomplete/index.tsx